exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-fileupload .ui-corner-top {\r\n  border-top-left-radius: 2px;\r\n  border-top-right-radius: 2px;\r\n}\r\n.ui-fileupload .ui-corner-bottom {\r\n  border-bottom-left-radius: 2px;\r\n  border-bottom-right-radius: 2px;\r\n}\r\n.ui-fileupload .ui-button {\r\n  border-radius: 2px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/node_modules/css-loader?{"sourceMap":false,"import":false}!J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/primeng/file-upload/css/primeng.file-upload.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/primeng/file-upload/css/primeng.file-upload.css
// module chunks = styles